import React, { useState } from 'react';
import fullJsonData from '../masterDiseases.json';
import '../css/InputBox.css';
import checkMarkPng from '../images/checkmark.png';

function check4answer(userTyped) {
  const regex = /^[a-zA-Z0-9-'\s]*$/; // Allow letters, numbers, dashes, and spaces
  if (Array.isArray(fullJsonData)) {
    if (regex.test(userTyped)) {
      return fullJsonData.filter(entry => entry.name.toLowerCase().startsWith(userTyped.toLowerCase()));
    }
  }
  console.error('The data is not an array');
  return [];
}

function InputBox({ gameState, calculatePoints, addHint, diseaseName, addAnswer, getNextDisease }) {
  const [inputValue, setInputValue] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const handleChange = (event) => {
    const value = event.target.value;
    const regex = /^[a-zA-Z0-9-'\s]*$/; // Allow letters, numbers, dashes, and spaces
  
    if (regex.test(value) && value.length <= 64) { // Ensure the input doesn't exceed 64 characters
      setInputValue(value);
  
      if (value.length >= 3) {
        const results = check4answer(value);
        setFilteredResults(results);
      } else {
        setFilteredResults([]);
      }
    }
  };

  const handleItemClick = (item) => {
      setInputValue(item.name);
      setFilteredResults([]);
      setSelectedIndex(-1);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleImageClick(inputValue);
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      setSelectedIndex((prev) => Math.min(prev + 1, filteredResults.length - 1));
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setSelectedIndex((prev) => Math.max(prev - 1, 0));
    } else if (event.key === 'Tab') {
      event.preventDefault();
      if (filteredResults.length > 0) {
        const nextIndex = (selectedIndex + 1) % filteredResults.length;
        setSelectedIndex(nextIndex);
        const selectedItem = filteredResults[nextIndex];
        setInputValue(selectedItem ? selectedItem.name : '');
      }
    }
  };

  const handleImageClick = (value) => {
    if (!gameState.isGameOver) {
      if (value.toLowerCase() === diseaseName.toLowerCase()) {
        let color, emoji;
        const ratio = (gameState.userHints - 1) / (gameState.maxHints);
        if (ratio > 0.8) {
          color = 'orange';
          emoji = '🟧';
        } else if (ratio > 0.6) {
          color = 'rgb(189, 177, 70)';
          emoji = '🟨';
        } else if (ratio > 0) {
          color = 'green';
          emoji = '🟩';
        } else {
          color = 'blue';
          emoji = '🟦';
        }

        const answerObject = { name: diseaseName, color: color, emoji: emoji };
        calculatePoints();
        addAnswer(answerObject);
        getNextDisease();
        setInputValue('');
        setFilteredResults([]);
      } else {
        addHint();
      }
    }
  };

  return (
    <div className="input--container">
      <form onSubmit={(e) => e.preventDefault()} className="form-container">
        <input
          type="text"
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          className="text-input"
        />
        <img
          src={checkMarkPng}
          alt="Submit"
          className="submit-image"
          onClick={() => handleImageClick(inputValue)}
        />
      </form>
      {filteredResults.length > 0 && (
        <ul className="suggestions--box">
          {filteredResults.map((item, index) => (
            <li
              className={`list--entry ${selectedIndex === index ? 'selected' : ''}`}
              key={index}
              onClick={() => handleItemClick(item)}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default InputBox;
